import { userService } from "client-app-core";
import * as t from "./actionTypes";

const initialOnlineUsers = users => ({
	type: t.ONLINE_USERS_INITIAL,
	payload: { users }
});

const updateOnlineUsers = users => ({
	type: t.ONLINE_USERS_UPDATE,
	payload: { users }
});

const addOrUpdateOnlineUsers = users => ({
	type: t.ONLINE_USERS_ADD_OR_UPDATE,
	payload: { users }
});

const removeOnlineUsers = userIds => ({
	type: t.ONLINE_USERS_REMOVE,
	payload: { userIds }
});

/**
 * Start /onlineUsers realtime stream.
 * Stores subscription in this feature slice so it works with dynamic reducers too.
 */
export const startOnlineUsersStream = () => {
	return (dispatch, getState) => {
		const existing = getState()?.appState?.dock?.onlineUsers?.stream?.subscription;
		if (existing) return Promise.resolve(existing);

		return userService
			.streamOnlineUsers((err, payload) => {
				if (err) {
					console.error("onlineUsers stream error:", err);
					return;
				}
				if (!payload) return;

				// Supports snapshot or delta payloads
				switch (payload.type) {
					case "initial":
						dispatch(initialOnlineUsers(payload.users || []));
						break;

					case "update":
						dispatch(updateOnlineUsers(payload.users || []));
						break;

					case "addOrUpdate":
						dispatch(addOrUpdateOnlineUsers(payload.users || []));
						break;

					case "remove":
						dispatch(removeOnlineUsers(payload.userIds || []));
						break;

					default:
						// fallback: if it looks like a snapshot, treat as update
						if (Array.isArray(payload.users)) {
							dispatch(updateOnlineUsers(payload.users));
						}
				}
			})
			.then(subscription => {
				dispatch({
					type: t.ONLINE_USERS_STREAM_STARTED,
					payload: { subscription }
				});
				return subscription;
			});
	};
};

export const stopOnlineUsersStream = () => {
	return (dispatch, getState) => {
		const subscription = getState()?.appState?.dock?.onlineUsers?.stream?.subscription;

		try {
			// depending on your realtime client, this might be unsubscribe() or unsubscribe
			if (subscription?.unsubscribe) subscription.unsubscribe();
		} catch (e) {
			// ignore
		}

		dispatch({ type: t.ONLINE_USERS_STREAM_STOPPED });
	};
};
